@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.registration-error {
  margin-bottom: 20px;
}

.provider-row-logo {
  height: 30px;
  width: 30px;
  min-width: 30px;

  > img {
    height: 100%;
    width: 100%;
  }
}

.active-checkmark {
  color: @settings-page--shipping-carriers-list-check--icon-color;
  width: 16px;
}

.table-button {
  padding: 8px 12px;
  border-radius: 6px;

  &:hover,
  &:focus {
    background-color: @settings-page--shipping-carriers-list-button--hover--background-color;
    color: @settings-page--shipping-carriers-list-button--hover--text-color;
  }
  &:active {
    background-color: @settings-page--shipping-carriers-list-button--active--background-color;
  }
}

.nickname-button {
  margin-left: -12px;
}

.menu-toggle {
  height: 32px;
  width: 32px;

  border-radius: 6px;

  color: @settings-page--shipping-carriers-list-menu--text-color;

  &:hover,
  &:focus {
    background-color: @settings-page--shipping-carriers-list-menu--hover--background-color;
    color: @settings-page--shipping-carriers-list-menu--hover--text-color;
  }

  &:active {
    background-color: @settings-page--shipping-carriers-list-menu--active--background-color;
    color: @settings-page--shipping-carriers-list-menu--active--text-color;
  }
}

.open-menu-toggle {
  background-color: @settings-page--shipping-carriers-list-open-menu--background-color;
  color: @settings-page--shipping-carriers-list-open-menu--text-color;
}

.menu-toggle-contents {
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    width: 16px;
  }
}

.balance {
  display: inline-block;
  margin-right: 0;
  font-weight: 300;
  font-size: 12px;
  margin-left: 10px;
}

.pending-status {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 60px;
  border-radius: 10px;
  background: @settings-page--shipping-carriers-list-pending--background-color;
  border-color: @settings-page--shipping-carriers-list-pending--border-color;
  color: @settings-page--shipping-carriers-list-pending--text-color;
  font-size: 12px;
  margin-left: 10px;
}

.discontinued {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  border-radius: 10px;
  background: @settings-page--shipping-carriers-list-discontinued--background-color;
  color: @settings-page--shipping-carriers-list-discontinued--text-color;
  font-size: 12px;
  margin-left: 10px;
  padding: 0 10px;
  border: 1px solid @settings-page--shipping-carriers-list-discontinued--border-color;
}
